/**
 * Review moment / Post Stream Review eligibility check.
 *
 * Returns true when the user is in the Milestone 1 streaming UX cohort **and** on
 * the xstate / orchestrator path. Review moment cannot run without xstate
 * (`buildCommitTransaction` bails if the streaming plugin is unregistered, and
 * the PSR UI shares modal anchoring with the legacy prompt).
 */
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';
import { expValEqualsNoExposure } from '@atlaskit/tmp-editor-statsig/exp-val-equals-no-exposure';

import {
	isStreamingUxExperienceM1Enabled,
	isStreamingUxExperienceM1EnabledNoExposure,
} from './streaming-ux-experience-m1-enabled';

/**
 * Returns true when Review moment is eligible: xstate migration AND the M1
 * streaming UX experiment. See file-level JSDoc for why both are required.
 *
 * This variant **logs an experiment exposure** (M1 last, so xstate short-circuits
 * first). Use it only at canonical, action-driven gate-enforcement points — not
 * in render paths that run on every re-render.
 */
export function isNewAifcExperienceEnabled(): boolean {
	return (
		expValEquals('platform_editor_ai_xstate_migration', 'isEnabled', true) &&
		isStreamingUxExperienceM1Enabled()
	);
}

/**
 * Non-exposure-logging counterpart of `isNewAifcExperienceEnabled`.
 *
 * Use this at render-time / read-only call sites where the canonical exposure
 * has already been logged at the gate-enforcement point.
 */
export function isNewAifcExperienceEnabledNoExposure(): boolean {
	return (
		expValEqualsNoExposure('platform_editor_ai_xstate_migration', 'isEnabled', true) &&
		isStreamingUxExperienceM1EnabledNoExposure()
	);
}
